import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Payments, Checklist, Landing, LogIn, Careers, Services, ThankYou } from "../pages";
import App from "../app/App";

function AppRouter() {
    return (
        <Router>
            <App>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/checklist" element={<Checklist />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/payments" element={<Payments />} />
                    <Route path="/log-in" element={<LogIn />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                </Routes>
            </App>
        </Router>
    );
}

export default AppRouter;
